<template>
  <v-container id="scroll-target" class="px-1 overflow-y-auto overflow-x-hidden" fluid :style="maxHeight">
    <v-fab-transition>
      <v-btn v-if="toTopButton && scrollType !== 'box'" absolute class="button-fixed" color="primary" dark fab right @click="scrollToTop">
        <mf-icon>expand_less</mf-icon>
      </v-btn>
    </v-fab-transition>
    <div v-scroll:#scroll-target="onScroll">
      <slot></slot>
    </div>
    <v-slide-x-transition>
      <v-row justify="center" style="height: 50px">
        <v-progress-circular v-if="loadingData" color="primary" indeterminate></v-progress-circular>
      </v-row>
    </v-slide-x-transition>
  </v-container>
</template>

<script>
export default {
  name: 'InfiniteScroll',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    percentualUpdate: {
      type: Number,
      default: 99,
    },
    height: {
      type: String,
      default: '100%',
    },
    // scrollType: box or screen
    scrollType: {
      type: String,
      default: 'screen',
      validator: (value) => ['box', 'screen'].indexOf(value) !== -1,
    },
  },
  data: () => ({
    toTopButton: false,
    timeout: null,
  }),
  computed: {
    maxHeight() {
      return `max-height: ${this.height}`
    },
    loadingData: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  created() {
    window.onscroll = () => {
      const {
        documentElement: { scrollTop, offsetHeight, scrollHeight },
      } = document

      const scrolledPercentual = ((scrollTop + offsetHeight) * 100) / scrollHeight

      this.showButton(scrolledPercentual)

      if (scrolledPercentual >= this.percentualUpdate) {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.$emit('update-data')
        }, 2000)
      }
    }
  },
  methods: {
    onScroll(e) {
      const { scrollTop, offsetHeight, scrollHeight } = e.target
      const scrolledPercentual = ((scrollTop + offsetHeight) * 100) / scrollHeight

      if (scrolledPercentual >= this.percentualUpdate) {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.$emit('update-data')
        }, 750)
      }
    },
    scrollToTop() {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },
    showButton(scrolledPercentual) {
      const {
        documentElement: { offsetHeight, scrollHeight },
      } = document
      const startScroll = (offsetHeight * 100) / scrollHeight
      const multiplicationNumber = startScroll * 2 > 60 ? 1.5 : 2
      const percentualShowButton = startScroll * multiplicationNumber

      if (scrolledPercentual >= percentualShowButton) {
        this.toTopButton = true
        return
      }
      this.toTopButton = false
    },
  },
}
</script>

<style>
html {
  scroll-behavior: smooth;
}
.button-fixed {
  position: fixed;
  bottom: 10px;
}
</style>
